export default "__VITE_ASSET__b8adbe3b__"